import { Phone, ArrowUp, MessageCircle } from "lucide-react";
import { useZeoContent } from "../lib/ZeoContentContext";
import { useScrollThreshold } from "../hooks/use-scroll-threshold";

export default function FloatingButtons() {
  const { business } = useZeoContent();
  const showTop = useScrollThreshold(600);

  return (
    <>
      {/* WhatsApp */}
      <a
        href={business.social.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        data-testid="floating-whatsapp"
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#D4A15C] hover:bg-[#B8863F] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(212,161,92,0.35)] hover:scale-110 transition-transform animate-pulse-ring"
      >
        <MessageCircle className="w-6 h-6" />
      </a>

      {/* Phone */}
      <a
        href={`tel:${business.phoneRaw}`}
        aria-label="Telefon"
        data-testid="floating-phone"
        className="fixed bottom-24 right-6 z-40 w-14 h-14 rounded-full bg-[#A85C34] hover:bg-[#8B4726] text-white flex items-center justify-center shadow-[0_10px_30px_rgba(168,92,52,0.35)] hover:scale-110 transition-transform"
      >
        <Phone className="w-6 h-6" />
      </a>

      {/* Scroll-to-top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Yukarı çık"
        data-testid="floating-scroll-top"
        className={`fixed bottom-6 left-6 z-40 w-12 h-12 rounded-full bg-white text-[#222222] border border-[#EAEAEA] flex items-center justify-center shadow-[0_10px_30px_rgba(0,0,0,0.1)] hover:scale-110 transition-all duration-300 ${
          showTop ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </>
  );
}
